import * as React from 'react'
import glamorous from 'glamorous'
import { InjectedFormikProps } from 'formik'

import { Props } from '../../pages/Login/Login'
import { Values } from '../../../containers/pages/LoginForm/LoginForm'

import { Alert } from '../../common/Alert/Alert'
import { Input } from '../../common/Input/Input'
import { SubmitButton } from '../../common/SubmitButton/SubmitButton'

import { FormTitle } from './components/FormTitle/FormTitle'
import { Form } from './components/Form/Form'

import { StyledLoginForm } from './LoginForm.glamorous'

export const StyledInput = glamorous(Input)({
  padding: '0 80px 20px',
})

export const LastStyledInput = glamorous(StyledInput)({
  padding: '0 80px 40px',
})

export class LoginForm extends React.Component<InjectedFormikProps<Props, Values>> {

  constructor(props: any) {
      super(props)
  }

  handleFocus = (event: any) => event.target.previousSibling.classList += ' active'

  render() {

    return (
      <StyledLoginForm>

        <FormTitle>Login</FormTitle>

        {(!!Object.keys(this.props.errors).length && !!Object.keys(this.props.touched).length) && (
            Object.keys(this.props.errors).filter(
                (msg) => Object.keys(this.props.touched).includes(msg)).map((error, idx) => {
              const msg = this.props.errors[error]
              return (
                <Alert type="error">
                <p key={`${error}${idx}`}>{`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`}</p>
                </Alert>
              )
            })
        )}

        {(this.props.userError !== '')
          ? (<Alert type="error"><p key={0}>{`${this.props.userError}`}</p></Alert>)
          : null}

        {(this.props.recoverSuccess)
          ? (<Alert type="success"><p>Thank you, your password has been reset, please log in to continue.</p></Alert>)
          : null}

        <Form onSubmit={this.props.handleSubmit}>
          <StyledInput
            error={this.props.touched.email && this.props.errors.hasOwnProperty('email')}
            id="email"
            label="Email"
            onBlur={this.props.handleBlur}
            onChange={this.props.handleChange}
            placeholder="Email"
            required={true}
            tabIndex={1}
            type="email"
            value={this.props.values.email}
            autoComplete="nope"
            onFocus={(event) => this.handleFocus(event)}
          />
          <LastStyledInput
            error={this.props.touched.password && this.props.errors.hasOwnProperty('password')}
            id="password"
            label="Password"
            last={true}
            onBlur={this.props.handleBlur}
            onChange={this.props.handleChange}
            placeholder="Password"
            required={true}
            tabIndex={2}
            type="password"
            autoComplete="new-password"
            value={this.props.values.password}
            onFocus={(event) => this.handleFocus(event)}
          />
          <SubmitButton
            disabled={!this.props.isValid || this.props.isSubmitting}
            type="submit"
          >
            Login
          </SubmitButton>
        </Form>
      </StyledLoginForm>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/LoginForm/LoginForm.tsx